export enum TooltipPosition {
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right',
  DYNAMIC = 'dynamic',
  DEFAULT = 'above',
}
